module.exports = __webpack_public_path__ + "static/Canela-RegularItalic-60cd002219b3d46d1d594d482e4ee9ce.otf";